import React, { useEffect, useState } from "react";
import TotalItemsImg from "../../images/total items.svg";
import TotalSoldItemsImg from "../../images/total sold items.svg";
import TotalStockValueImg from "../../images/total stock value.svg";
import ReceiveImg from "../../images/You’ll Receive.svg";
import CashInHandImg from "../../images/cash in hand.svg";
import PayImg from "../../images/pay image.svg";
import TotalSaleImg from "../../images/total sale.svg";
import SaleOrders from "../../images/sale orders.svg";
import { Grid } from "@mui/material";
import { CbBox } from "../styles";
import { Link } from "react-router-dom";
import { ItemBox, Title } from "./styles";
import Repo from "../../Repository/Repo";
import useGetProperties from "../../pages/property/useGetProperties";
import moment from "moment";
import AddProperty from "../../pages/property/Add";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

function TopCards({ totalItems, totalPrice, totalSale,     totalSaleStock, totalSold,totalProfit , totalCashInHand,totalBankBalance,  totalPayments,totalSales}) {
  console.log('cash', totalCashInHand)
  console.log('totalSale', totalSale)

  const companyCode = localStorage.getItem("companyCode");
  console.log(companyCode)
  const [banksData, setBanksData] = useState(0);
  const [cashInHand, setCashInHand] = useState(0);
  const [ledgersData, setLedgersData] = useState("");
  const [ordersValue, setOrderValue] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (companyCode != 4416 && companyCode != 9478) {
      //  getBankRecords();
      // getCashInHands();
      getLedgers();
      getOrdersInfo();
    }
  }, []);

  const { loading, records } = useGetProperties();

  const toggle = () => {
    setOpen((prev) => !prev);
  };

  const getBankRecords = async () => {
    try {
      let { data } = await Repo.banks({
        request: {
          method: "getBanksByCompany",
          data: {
            company_code: companyCode,
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        let total = 0;
        data.response.data.banks.forEach((i) => {
          total += parseInt(i?.balance) || 0;
        });
        setBanksData(total);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };
  // const getCashInHands = async () => {
  //   try {
  //     let { data } = await Repo.banks({
  //       request: {
  //         method: "getOutOfStockItems",
  //         data: {
  //           company_code: localStorage.getItem("companyCode"),
  //         },
  //       },
  //     });
  //     console.log("data:", data);
  //     // if (data.response.status.statusCode == 200) {
  //     //   setRecords(data.response.data.banks);
  //     // }
  //   } catch (err) {
  //     console.log("err:", err);
  //   }
  // };
  const getLedgers = async () => {
    let { data } = await Repo.ledger({
      request: {
        method: "getLedgersByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
          ledgerRegions: [],
          next_page_token: "",
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      const { salesTotal, purchasesTotal } = data.response.data;
      setLedgersData({ salesTotal, purchasesTotal });
    }
  };
  const getOrdersInfo = async () => {
    try {
      let { data } = await Repo.orders({
        request: {
          method: "getOrdersInfo",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        setOrderValue(data.response.data?.amountOpenOrders);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getNewRecords = () => {
    let today = moment().format("DD-MM-YYYY");
    let count = 0;
    records.forEach((i) => {
      let date = moment(i.created_at).format("DD-MM-YYYY");
      if (today == date) {
        count += 1;
      }
    });
    return count;
  };

  return (
    <>
      {companyCode != 4416 && (
        <Grid container spacing="16px" mt="16px">
          <Grid item md={3} sm={6} xs={12}>
            <Link to="/inventory/admin/inventory">
              <ItemBox>
                <Title>Total Items</Title>
                <CbBox>
                  <Title>
                    {totalItems % 1 == 0
                      ? totalItems
                      : parseFloat(totalItems).toFixed(3)}
                  </Title>
                  <img src={TotalItemsImg} width="70px" />
                </CbBox>
              </ItemBox>
            </Link>
          </Grid>

          <Grid item md={3} sm={6} xs={12}>
            <ItemBox>
              <Title>Total Sold Items</Title>
              <CbBox>
                <Title>
                  {totalSold % 1 == 0
                    ? totalSold
                    : parseFloat(totalSold).toFixed(3)}
                </Title>
                <img src={TotalSoldItemsImg} width="70px" />
              </CbBox>
            </ItemBox>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <ItemBox>
              <Title>Total Stock Value</Title>
              <CbBox>
                <Title>{parseInt(totalPrice)}</Title>
                <img src={TotalStockValueImg} width="70px" />
              </CbBox>
            </ItemBox>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <ItemBox>
              <Title>Total Stock Sale Value</Title>
              <CbBox>
                <Title>{parseInt(totalSaleStock)}</Title>
                <img src={TotalStockValueImg} width="70px" />
              </CbBox>
            </ItemBox>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <ItemBox>
              <Title>Total Sale</Title>
              <CbBox>
                <Title>{parseInt(totalSales)}</Title>
                <img src={TotalSaleImg} width="70px" />
              </CbBox>
            </ItemBox>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Link to="/inventory/admin/ledgers">
              <ItemBox>
                <Title>You'll Receive</Title>
                <CbBox>
                  <Title>{Number(ledgersData?.salesTotal).toFixed(3) || 0}</Title>
                  <img src={ReceiveImg} width="70px" />
                </CbBox>
              </ItemBox>
            </Link>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Link to="/inventory/admin/ledgers">
              <ItemBox>
                <Title>You'll Pay</Title>
                <CbBox>
                  <Title>{ledgersData?.purchasesTotal || 0}</Title>
                  <img src={PayImg} width="70px" />
                </CbBox>
              </ItemBox>
            </Link>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Link to="/inventory/admin/cash-in-hand">
              <ItemBox>
                <Title>Cash in hand</Title>
                <CbBox>
                  <Title>{totalCashInHand || 0}</Title>
                  <img src={CashInHandImg} width="70px" />
                </CbBox>
              </ItemBox>
            </Link>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Link to="/inventory/admin/bank-accounts">
              <ItemBox>
                <Title>Bank Accounts</Title>
                <CbBox>
                  <Title>{totalBankBalance || 0}</Title>
                  {/* <img src={banksData || 0} width="70px" /> */}
                  <AccountBalanceIcon
                    sx={{
                      mr: 2,
                      ml: 0.8,
                      fontSize: "70px",
                      color: "grey",
                    }}
                  />
                </CbBox>
              </ItemBox>
            </Link>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Link to="/inventory/admin/store">
              <ItemBox>
                <Title>Sale Orders</Title>
                <CbBox>
                  <Title>{ordersValue || 0}</Title>
                  <img src={SaleOrders} width="70px" />
                </CbBox>
              </ItemBox>
            </Link>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Link to="/inventory/admin/daily-book">
              <ItemBox>
                <Title>Total Profit</Title>
                <CbBox>
                  <Title>{totalProfit || 0}</Title>
                  <img src={SaleOrders} width="70px" />
                </CbBox>
              </ItemBox>
            </Link>
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <Link to="/inventory/admin/payment">
              <ItemBox>
                <Title>Total Payments</Title>
                <CbBox>
                  <Title>{totalPayments|| 0}</Title>
                  <img src={CashInHandImg} width="70px" />
                </CbBox>
              </ItemBox>
            </Link>
          </Grid>
        </Grid>
      )}
      {companyCode == 4416 && (
        <Grid container spacing="16px" mt={{ xs: "48px", md: "16px" }}>
          <Grid item md={6} xs={12}>
            <Link to="/inventory/admin/property" sx={{ cursor: "pointer" }}>
              <ItemBox>
                <Title sx={{ fontSize: "25px" }}>Total Entries</Title>
                <CbBox>
                  <Title sx={{ fontSize: "25px" }}>
                    {(records && records.length) || 0}
                  </Title>
                  <img src={TotalItemsImg} width="70px" />
                </CbBox>
              </ItemBox>
            </Link>
          </Grid>

          <Grid item md={6} xs={12}>
            <ItemBox onClick={toggle} sx={{ cursor: "pointer" }}>
              <Title sx={{ fontSize: "25px" }}>New Entries</Title>
              <CbBox>
                <Title sx={{ fontSize: "25px" }}>{getNewRecords()}</Title>
                <img src={TotalSoldItemsImg} width="70px" />
              </CbBox>
            </ItemBox>
          </Grid>
        </Grid>
      )}
      {open && <AddProperty onClose={toggle} onSuccess={toggle} />}
    </>
  );
}

export default TopCards;
